import {Injectable} from '@angular/core';
import {WebLead} from '../../model/leads/WebLead';
import {WebLeadType} from '../../model/leads/WebLeadType';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {QuotationService} from '../quotation-service/quotation.service';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {CreateLeadResponse} from 'src/app/model/leads/CreateLeadResponse';
import {isNullOrUndefined} from 'util';
import {CrossSellRecommendation} from '../../model/cross-sell-recommendation';
import {ParkingSecurity} from "../../model/ParkingSecurity";

@Injectable()
export class LeadService {
  private _createLeadResponse: CreateLeadResponse = new CreateLeadResponse();
  private _updateLeadResponse: CreateLeadResponse;
  private _doesUserHaveProduct: Boolean;
  private _apiURL = environment.apiUrl;
  private _originNode: string = null;
  private _clickedGetAQuote: string = null;
  private _fragment: string = null;
  private _crossSellRecommendation: CrossSellRecommendation;
  private _leadComment: string;
  private _secondaryDriver: string;
  private _quoteDetail: string;
  private _insureRecommendedQuote: string;
  constructor(private http: HttpClient,
              private quotationService: QuotationService) {
  }

  get clickedGetAQuote(): string {
    return this._clickedGetAQuote;
  }

  set clickedGetAQuote(value: string) {
    this._clickedGetAQuote = value;
  }

  get originNode(): string {
    return this._originNode;
  }

  set originNode(value: string) {
    this._originNode = value;
  }

  get apiURL(): string {
    return this._apiURL;
  }

  set apiURL(value: string) {
    this._apiURL = value;
  }

  get createLeadResponse(): CreateLeadResponse {
    return this._createLeadResponse;
  }

  set createLeadResponse(value: CreateLeadResponse) {
    this._createLeadResponse = value;
  }

  get updateLeadResponse(): CreateLeadResponse {
    return this._updateLeadResponse;
  }

  set updateLeadResponse(value: CreateLeadResponse) {
    this._updateLeadResponse = value;
  }

  get doesUserHaveProduct(): Boolean {
    return this._doesUserHaveProduct;
  }

  set doesUserHaveProduct(value: Boolean) {
    this._doesUserHaveProduct = value;
  }

  get fragment(): string {
    return this._fragment;
  }

  set fragment(value: string) {
    this._fragment = value;
  }

  get crossSellRecommendation(): CrossSellRecommendation {
    return this._crossSellRecommendation;
  }

  set crossSellRecommendation(value: CrossSellRecommendation) {
    this._crossSellRecommendation = value;
  }

  get secondaryDriver(): string {
    return this._secondaryDriver;
  }

  set secondaryDriver(value: string) {
    this._secondaryDriver = value;
  }
  get leadComment(): string {
    return this._leadComment;
  }

  set leadComment(value: string) {
    this._leadComment = value;
  }

  get quoteDetail(): string {
    return this._quoteDetail;
  }

  set quoteDetail(value: string) {
    this._quoteDetail = value;
  }

  get insureRecommendedQuote(): string {
    return this._insureRecommendedQuote;
  }

  set insureRecommendedQuote(value: string) {
    this._insureRecommendedQuote = value;
  }

  registerLead(type: WebLeadType): Observable<HttpResponse<any>> {
    const webLead: WebLead = this.createWebLeadFromRequestTemplate();
    const body = {
      name: webLead.name,
      surname: webLead.surname,
      legalRefType: webLead.legalRefType,
      id: webLead.idNumber ? webLead.idNumber : this.quotationService.quotationRequest.passportNumber,
      cellphone: webLead.cellPhone,
      leadType: type,
      email: webLead.email,
      platform: webLead.platform,
      campaign: webLead.campaign,
      originNode: webLead.originNode,
      medium: webLead.medium,
      fbClickID: webLead.fbClickID,
      fbBrowserID: webLead.fbBrowserID,
      urlParams: webLead.urlParams
    };
    return this.http.post(this.apiURL + '/leads/submitLead', body, {headers: environment.plainHeaders, observe: 'response'});
  }

  registerEarlyExitLead(type: WebLeadType): Observable<HttpResponse<any>> {
    const webLead: WebLead = this.createWebLeadFromRequestTemplate();
    const body = {
      name: webLead.name,
      cellphone: webLead.cellPhone,
      leadType: type,
      campaign: webLead.campaign,
      medium: webLead.medium,
      comment: webLead.comment
    };
    return this.http.post(this.apiURL + '/leads/submitLead', body, {headers: environment.plainHeaders, observe: 'response'});
  }

  createWebLeadFromRequestTemplate(): WebLead {
    const webLead: WebLead = new WebLead();
    webLead.name = this.quotationService.quotationRequest.name;
    webLead.surname = this.quotationService.quotationRequest.surname;
    webLead.cellPhone = this.quotationService.quotationRequest.cellphone;
    webLead.legalRefType = this.quotationService.quotationRequest.legalRefType;
    webLead.idNumber = this.quotationService.quotationRequest.idNumber;
    webLead.email = this.quotationService.quotationRequest.email;
    webLead.platform = this.quotationService.platform;
    webLead.campaign = this.quotationService.quotationRequest.campaign;
    webLead.originNode = isNullOrUndefined(this.originNode) ? null : this.originNode;
    webLead.comment = this.quotationService.quotationRequest.comment;
    webLead.medium = this.quotationService.quotationRequest.medium;
    webLead.fbBrowserID = this.quotationService.quotationRequest.fbBrowserID;
    webLead.fbClickID = this.quotationService.quotationRequest.fbClickID;
    webLead.urlParams = this.quotationService.quotationRequest.urlParams;
    return webLead;
  }

  updateLead(type?: WebLeadType, recommendedQuote: String = null, selectedQuote: String = null, error?: string, campaign?: string, medium?: string, source?: string, leadComment?: string): Observable<any> {

    const body = {
      leadType: type,
      recommendedQuote: recommendedQuote,
      selectedQuote: selectedQuote,
      vehicleUsage: this.quotationService.quotationRequest.vehicleUsage,
      parkingSecurity: this.quotationService.quotationRequest.parkingSecurity,
      registrationNumber: this.quotationService.quotationRequest.vehicleDetails.registrationNumber,
      vinNumber: this.quotationService.quotationRequest.vehicleDetails.vinNumber,
      parkingAddress: this.quotationService.quotationRequest.parkingAddress.addressDescr,
      medium: medium,
      source: source,
      leadComment: leadComment || this.leadComment,
      secondaryDriver: this.secondaryDriver,
      quoteDetail: this.quoteDetail,
      insureRecommendedQuote: this.insureRecommendedQuote
    };

    if (error) {
      body['error'] = error.replace(/<.*?>/g, '');
    }

    if (campaign) {
      body['utmCampaign'] = campaign;
    }
    if (this.clickedGetAQuote != null) {
      body['clickedGetAQuote'] = this.clickedGetAQuote;
    }

    return this.http.post(this.apiURL + '/leads/updateLead', body, {headers: environment.plainHeaders});
  }


  commercialUsage(): Observable<any> {
    let leadReferenceNumber = null;
    if (this.createLeadResponse) {
      leadReferenceNumber = this.createLeadResponse.leadReferenceNumber;
    } else {
      return null;
    }
    return this.http.post(this.apiURL + '/leads/commercialUsage', leadReferenceNumber, {headers: environment.plainHeaders});
  }

  getCrossSellProductFragment() {
    return this.http.get(this.apiURL + '/getInsureFragment', {headers: environment.plainHeaders});
  }

  getCrossSellRecommendation(): Observable<any>   {
    return this.http.get(this.apiURL + '/getInsureRecommendation');
  }

  cacheLeadReference(leadRef: String): Observable<any> {
    return this.http.post(this.apiURL + '/leads/cacheLeadReference/' + leadRef, {headers: environment.plainHeaders});
  }
}
